import { create } from 'zustand';

interface UserState {
  user: any; // TODO: @JB ADD CORRECT TYPES
  login: (user: any) => void;
  logout: () => void;
}

export const useUserStore = create<UserState>((set) => ({
  user: JSON.parse(localStorage.getItem('user') ?? 'null'),
  login: (user) => {
    // backward compatibility
    localStorage.setItem('user', JSON.stringify(user));
    localStorage.setItem('userLogedIn', 'true');
    return set({ user });
  },
  logout: () => {
    // backward compatibility
    localStorage.removeItem('user');
    return set({ user: null });
  },
}));

export const isLoggedIn = () => {
  const val = localStorage.getItem('user');
  const user = JSON.parse(val ?? 'null');
  const token = user?.token;
  return !!token;
};
